export const DROPDOWN_LIST_HEIGHT = 150
